var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isLoading)?_c('div',{staticClass:"ui-list-loader"},[_c('ui-loader')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }